export default class Title {
  public id: number;

  public title: string;

  constructor(id: number, title: string) {
    this.id = id;
    this.title = title;
  }
}
